module.exports = __webpack_public_path__ + "static/img/40-北京第七中学.a247579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/40-北京第七中学.png
// module id = z6HJ
// module chunks = 0